import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { useCart } from "@/common/Contexts/CartContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import useIsBrowser from "@hooks/useIsBrowser";
var OilHeader = function OilHeader() {
  var _useCart = useCart(),
    totalItems = _useCart.totalItems;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var lang = useLang();
  var isBrowser = useIsBrowser();
  return /*#__PURE__*/React.createElement("div", {
    className: "md:hidden sticky top-0 z-30 flex items-center justify-between px-4 py-3 bg-white border-solid border-b border-[#E1E8F2]"
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/"),
    "aria-label": "back",
    className: "flex items-center justify-center w-9 h-9 rounded-xl bg-transparent border-none cursor-pointer hover:bg-[#F4F6FB] transition-colors"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: lang === "en" ? "material-symbols--arrow-back-ios-rounded" : "material-symbols--arrow-forward-ios-rounded",
    className: "text-[#0d0db5]",
    width: 4,
    height: 4
  })), isBrowser && totalItems > 0 && /*#__PURE__*/React.createElement("a", {
    href: createUrl("/site/cart"),
    "aria-label": "cart",
    className: "relative flex items-center justify-center w-9 h-9 rounded-xl hover:bg-[#F4F6FB] transition-colors"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--shopping-cart-outline-rounded",
    className: "text-[#0d0db5]",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("span", {
    className: "absolute -top-1 -left-1 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-[#EC6234] text-white text-[10px] font-bold leading-none"
  }, totalItems > 99 ? "99+" : totalItems)));
};
export default OilHeader;